import { useQuery } from '@tanstack/react-query';
import { useLocation as useRouterLocation } from 'react-router-dom';
import { useLocation } from '@/shared/hooks/useLocation';
import { useAuth } from '@/shared/hooks/useAuth';
import { overviewApi, type OverviewStateId } from '../api/overviewApi';
import { dashboardKeys } from '../queryKeys';

/**
 * True when `?demo=1` is present AND the signed-in user is an agency user — gates the demo
 * switcher UI. `isAgency` is computed server-side at login (see AuthContext.tsx) and is the same
 * signal `routes.tsx`'s `AgencyRoute` already gates on.
 */
export function useDemoEnabled(): boolean {
  const { search } = useRouterLocation();
  const { user } = useAuth();
  return user?.isAgency === true && new URLSearchParams(search).get('demo') === '1';
}

export function useOverview(demoStateOverride?: OverviewStateId) {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  return useQuery({
    queryKey: dashboardKeys.overview(locationId, demoStateOverride),
    queryFn: () => overviewApi.get(locationId, demoStateOverride).then((r) => r.data),
    enabled: !!locationId,
    staleTime: 60_000,
  });
}
